import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { store } from './store/store';
import { Provider } from 'react-redux';
import App from './app';
import InitLoader from './components/InitLoader';
import './i18n';
import { initializeLanguageSystem } from './utils/language';
// Get root element
const rootElement = document.getElementById('root');
if (!rootElement) {
    console.error('Failed to find the root element.');
}
else {
    const root = ReactDOM.createRoot(rootElement);
    // Show loader immediately
    root.render(_jsx(InitLoader, {}));
    // Initialize language system in background
    initializeLanguageSystem()
        .then(() => {
        // Replace loader with the actual app
        root.render(_jsx(React.StrictMode, { children: _jsx(Provider, Object.assign({ store: store }, { children: _jsx(App, {}) })) }));
    })
        .catch((error) => {
        console.error('Failed to initialize language system:', error);
        // Fallback: render app anyway with default language
        root.render(_jsx(React.StrictMode, { children: _jsx(Provider, Object.assign({ store: store }, { children: _jsx(App, {}) })) }));
    });
}
